import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { WhatsAppOrderProvider } from "@/hooks/useWhatsAppOrder";
import WhatsAppOrderModal from "@/components/feature/WhatsAppOrderModal";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <WhatsAppOrderProvider>
          <div className="min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-1">
              <AppRoutes />
            </main>
            <Footer />
          </div>
          <WhatsAppOrderModal />
        </WhatsAppOrderProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;